import React, { useEffect, useState } from "react";
import { Avatar, Image, Progress, Button, Card, CardBody, Chip } from "@nextui-org/react";
import { getAlldata } from "../../controllers/APIController";
import { useNavigate } from "react-router-dom";
import logo from "../../Images/logo.svg";

import { Colors, numColors } from "../../utils/constant";
import OrgFrameworkInfo from "./OrgFrameworkInfo";
import OrgBasicInfo from "./OrgBasicInfo";
import OrgInviteInfo from "./OrgInviteInfo";
import { intialOrgData } from "../../constant/OnboardingOrganization/OnboardingOrganization";

import OrgFinancialInfo from "./OrgFinancialInfo";

const ProgessColors = ["danger", "secondary", "warning", "success"];

const steps = [
  { id: 0, label: "Organization Setup", description: "Create your organization" }
];

const OnboardingOrganization = () => {
  const [currentPage, setCurrrentPage] = useState(0);
  const totalStep = 1; // Simplified to just one step
  const [DataList, setDataList] = useState(intialOrgData);
  const [defaultOrgId, setDefaultOrgId] = useState(null);
  const [allUrlList, setUrlList] = useState([]);

  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const UserId = UserLogged && UserLogged.user.id;
  const email = UserLogged && UserLogged.user.email;

  const navigate = useNavigate();

  useEffect(() => {
    getAlldata("organizations")
      .then((data) => {
        const list = [];
        let defaultId = 0;
        data?.data?.forEach((item) => {
          list.push(item?.attributes?.URL);
          if (item?.attributes?.Name?.toLowerCase() === "default") {
            defaultId = item?.id;
          }
        });
        setUrlList(list);
        setDefaultOrgId(defaultId);
      })
      .catch((err) => {
        // Handle error silently
      });
  }, []);

  useEffect(() => {
    if (!UserLogged) {
      navigate("/sign-in");
    }
  }, []);

  const CurrentComp = () => {
    switch (currentPage) {
      case 0:
        return (
          <OrgBasicInfo
            TitleText={"Create Organization"}
            DescriptionText={"Let's start by creating your organization with just the basic information."}
            DataList={DataList}
            setDataList={setDataList}
            defaultOrgId={defaultOrgId}
            currentPage={currentPage}
            setCurrrentPage={setCurrrentPage}
            totalStep={totalStep}
            allUrlList={allUrlList}
          />
        );
      default:
        return null;
    }
  };


  const progressPercentage = Math.round(((currentPage + 1) / totalStep) * 100);

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
      <div className="bg-white border-b border-neutral-200 px-8 py-5 shadow-sm">
        <div className="flex items-center justify-between max-w-full">
          <div className="flex items-center space-x-3">
            <Image width={28} alt="Logo" src={logo} />
            <div>
              <h1 className="text-lg font-semibold text-neutral-900">Organization Setup - #{defaultOrgId || 1}</h1>
              <p className="text-sm text-neutral-600">Complete your organization onboarding</p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <Button 
              color="primary" 
              size="sm"
              className="bg-primary-600 hover:bg-primary-700 text-white px-6 font-medium"
              isDisabled={true}
              style={{ display: "none" }}
            >
              Submit
            </Button>
            <Avatar
              showFallback
              className="h-8 w-8 cursor-pointer ml-3"
              color={Colors[UserId % numColors]}
              name={email?.toUpperCase().slice(0, 1)}
              src="https://images.unsplash.com/broken"
            />
          </div>
        </div>
      </div>

      <div className="flex h-full">
        {/* Left Sidebar - Steps Navigation */}
        <div className="w-72 bg-neutral-50/50 border-r border-neutral-200 px-6 py-8">
          <div className="space-y-2">
            {steps.map((step, index) => (
              <button
                key={step.id}
                onClick={() => setCurrrentPage(step.id)}
                className={`w-full text-left px-4 py-3 rounded-md transition-all duration-200 ${
                  currentPage === step.id
                    ? 'bg-primary-50 border-l-4 border-primary-600 shadow-sm'
                    : currentPage > step.id
                    ? 'bg-primary-50/30 border-l-4 border-primary-400'
                    : 'hover:bg-neutral-50 border-l-4 border-transparent'
                }`}
              >
                <div className="flex items-center space-x-3">
                  <div className={`w-7 h-7 rounded-full flex items-center justify-center text-sm font-medium transition-colors ${
                    currentPage === step.id
                      ? 'bg-primary-600 text-white'
                      : currentPage > step.id
                      ? 'bg-primary-500 text-white'
                      : 'bg-neutral-200 text-neutral-600'
                  }`}>
                    {currentPage > step.id ? '✓' : index + 1}
                  </div>
                  <div className="flex-1">
                    <div className={`font-medium text-sm ${
                      currentPage === step.id ? 'text-neutral-900' : 'text-neutral-700'
                    }`}>
                      {step.label}
                    </div>
                    <div className="text-xs text-neutral-500 mt-0.5">{step.description}</div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Main Content Area */}
        <div className="flex-1 px-8 py-8">
          <div className="max-w-3xl">
            <div className="bg-white rounded-xl border border-neutral-200 shadow-lg shadow-neutral-200/50">
              <div className="px-8 py-8">
                {CurrentComp()}
              </div>
            </div>
          </div>
        </div>

        {/* Right Sidebar - Widgets */}
        <div className="w-80 bg-neutral-50/30 border-l border-neutral-200 px-6 py-8 space-y-5">
          {/* Progress Widget */}
          <div className="bg-white rounded-lg border border-neutral-200 shadow-md shadow-neutral-200/40 p-5">
            <div className="text-center">
              <h3 className="font-semibold text-neutral-900 mb-3">Progress</h3>
              <div className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800 mb-5">
                IN PROGRESS
              </div>
              <div className="relative w-24 h-24 mx-auto mb-4">
                <svg className="w-24 h-24 transform -rotate-90" viewBox="0 0 36 36">
                  <circle
                    cx="18"
                    cy="18"
                    r="16"
                    fill="none"
                    className="stroke-neutral-200"
                    strokeWidth="3"
                  />
                  <circle
                    cx="18"
                    cy="18"
                    r="16"
                    fill="none"
                    className="stroke-primary-600"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeDasharray={`${progressPercentage}, 100`}
                    style={{
                      transition: 'stroke-dasharray 0.6s ease-in-out'
                    }}
                  />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-lg font-bold text-neutral-900">{progressPercentage}%</span>
                </div>
              </div>
            </div>
          </div>

          {/* Current Step Info */}
          <div className="bg-white rounded-lg border border-neutral-200 shadow-md shadow-neutral-200/40 p-5">
            <h3 className="font-semibold text-neutral-900 mb-3">Current Step</h3>
            <div className="text-sm text-neutral-700 mb-2 font-medium">{steps[currentPage]?.label}</div>
            <div className="text-sm text-neutral-600 mb-3">{steps[currentPage]?.description}</div>
            <div className="text-xs text-neutral-500">
              Step {currentPage + 1} of {totalStep}
            </div>
          </div>

          {/* Help Widget */}
          <div className="bg-white rounded-lg border border-neutral-200 shadow-md shadow-neutral-200/40 p-5">
            <h3 className="font-semibold text-neutral-900 mb-3">Need Help?</h3>
            <div className="text-sm text-neutral-600 mb-4">
              Setting up your organization properly ensures accurate ESG reporting and compliance.
            </div>
            <Button 
              size="sm" 
              variant="flat" 
              color="primary"
              className="bg-primary-50 text-primary-700 hover:bg-primary-100 font-medium"
            >
              View Guide
            </Button>
          </div>

          {/* Organization Info */}
          {DataList.Name && (
            <div className="bg-white rounded-lg border border-neutral-200 shadow-md shadow-neutral-200/40 p-5">
              <h3 className="font-semibold text-neutral-900 mb-3">Organization</h3>
              <div className="text-sm text-neutral-700 mb-1 font-medium">{DataList.Name}</div>
              <div className="text-sm text-neutral-500">
                {DataList["Choose Your Region"] && `${DataList["Choose Your Region"]} • `}
                {DataList["Choose Industry Sector"]}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingOrganization;
